import styled from "@emotion/styled";
import { Tabs } from "antd";

const StyledTab = styled(Tabs)`
  .ant-tabs-nav {
    display: none;
  }
`;
export default StyledTab;
